import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ROUTES } from '../../../../consts/api-routes.const';
import { HttpService } from '../../../../services/http.service';
import { AuthenticationCodesResponse } from '../authentication-codes-response.interface';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http: HttpService = inject(HttpService);

  public start2fa(email: string): Observable<AuthenticationCodesResponse> {
    return this.http.post<AuthenticationCodesResponse>(API_ROUTES.AUTHENTICATE_CODES, {
      email: email,
    });
  }

  public getAuthenticate(email: string, code: string): Observable<AuthenticationCodesResponse> {
    return this.http.post<AuthenticationCodesResponse>(API_ROUTES.AUTHENTICATE_SESSIONS, {
      email: email,
      code: code,
    });
  }
}
